import { useAemConfig } from '@as-react/common-components';
export function useFeatureToggle(flagNames) {
    const { feature_toggles } = useAemConfig();
    if (Array.isArray(flagNames)) {
        return flagNames.map(name => !!feature_toggles[name]);
    }
    return !!feature_toggles[flagNames];
}
